import React from "react";
// import { slugify } from "../../utils";

const AllData = [
  // {
  //   image: "/images/icon/icon-2.png",
  //   title: "Strategy",
  //   // list: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
  //   list: [{ item: "One" }, { item: "One2" }, { item: "One32" }],
  //   description:
  //     "We carry more than just good coding skills. Our experience makes us stand out from other web development.",
  // },
  {
    image: "/images/icon/icon-4.png",
    title: "Marketing",
    link: "/service#section3",
    description:
      "From SEO to paid campaigns, our digital marketing team helps you reach the right audience and turn traffic into customers.",
  },
  {
    image: "/images/icon/icon-5.png",
    title: "IT Solutions",
    link: "/service",
    description:
      "From custom software to cloud and systems integration, we build the IT solutions that keep your business running smoothly.",
  },
  {
    image: "/images/icon/icon-6.png",
    title: "Staff Augmentation",
    link: "/Staff-Augmentation",
    description:
      "Extend your team with vetted developers and testers who plug straight into your workflow, on your timeline and budget.",
  },
];

const ServicePropOne = ({ colSize, serviceStyle, itemShow, marginTop }) => {
  const topMargin = (index) => {
    if (marginTop === "yes") {
      if (index === 0) {
        return "mt--200 mt_md--0";
      } else if (index === 1) {
        return "mt--100 mt_md--0";
      } else {
        return "mt--0";
      }
    } else {
      return "";
    }
  };

  return (
    <>
      {AllData.slice(0, itemShow).map((data, index) => (
        <div className={`${colSize} ${topMargin(index)}`} key={index}>
          <div  className={`services-grid ${serviceStyle}`}>
            <div className="thumbnail">
              <img
                src={process.env.PUBLIC_URL + data.image}
                alt="icon"
                loading="lazy"
                width="85"
                height="80"
              />
            </div>
            <div className="content">
              <h3 className="title">
                {/* <Link
                  to={
                    process.env.PUBLIC_URL +
                    `/service-details/${slugify(data.title)}`
                  }
                >
                  {data.title}
                </Link> */}
                <p>{data.title}</p>
              </h3>
              {/* <ul>
                <li>{AllData.list[0]}</li>
              </ul> */}
              <p>{data.description}</p>
              <a
                href={process.env.PUBLIC_URL + data.link}
                className="more-btn"
              >
                Find out more
              </a>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServicePropOne;
